/**
 * Created by Christof Sander on 07.12.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'dnd',
				'contextmenu',
				'node_customize'
			],
			core: {
				check_callback: function(operation, movingNode, targetNodeParent, nodePosition, more) {
					var result = false;
					if(operation === 'move_node'){
						var treesComponent;
						if(
							(more.origin.element && (treesComponent = getComponent($(more.origin.element).closest('.base_trees_trees'))))
							||
							(treesComponent = getComponent(this.$.closest('.base_trees_trees')))
						){
							var treeComponentIndex, nodeData;
							var parentNodeTreeComponentIndex, parentNodeData;

							if(movingNode.id){
								treeComponentIndex 	= treesComponent.getNodeTreeComponentIndex(movingNode.id);
								nodeData 			= treesComponent.getNodeData(movingNode.id, treeComponentIndex) || {};

								if(nodeData.id){
									targetNodeParent = targetNodeParent || {};
									if(targetNodeParent.id && targetNodeParent.id != '#'){
										parentNodeTreeComponentIndex 	= treesComponent.getNodeTreeComponentIndex(targetNodeParent.id);
										parentNodeData					= treesComponent.getNodeData(targetNodeParent.id, parentNodeTreeComponentIndex);
									}

									result = nodeData.type != 'language' || !parentNodeData;
								}
							}
						}
					}
					return result;
				}
			},
			contextmenu: {
				items: {
					editContent: {
						separator_before: false,
						separator_after: false,
						_disabled: false,
						labelKey: 'contextMenu.route.editContent',
						titleKey: 'contextMenu.route.editContent',
						action: function(event){
							utils.performButtonAction(undefined, undefined, {}, {
								fieldType: 'edit',
								context: 'routeContent',
								componentInCharge: getComponent(event.reference.closest('.base_trees_tree'))
							});
						},
						icon: 'fi fi-edit',
						// shortcut: 13,
						// shortcut_label: 'Enter',
						submenu: false
					},
					open: {
						separator_before: false,
						separator_after: false,
						_disabled: false,
						labelKey: 'contextMenu.route.open',
						titleKey: 'contextMenu.route.open',
						action: function(event){
							utils.performButtonAction(undefined, undefined, {}, {
								fieldType: 'open',
								context: 'routes',
								componentInCharge: getComponent(event.reference.closest('.base_trees_tree'))
							});
						},
						icon: 'fi fi-open-routes',
						// shortcut: 13,
						// shortcut_label: 'Enter',
						submenu: false
					},
					showDuplicate: {
						separator_before: false,
						separator_after: false,
						_disabled: false,
						labelKey: 'contextMenu.route.duplicate',
						titleKey: 'contextMenu.route.duplicate',
						action: function(event){
							utils.performButtonAction(undefined, undefined, {}, {
								fieldType: 'showDuplicate',
								context: 'route',
								componentInCharge: getComponent(event.reference.closest('.base_trees_tree'))
							});
						},
						icon: 'fi fi-copy',
						// shortcut: 13,
						// shortcut_label: 'Enter',
						submenu: false
					},
					cut: {
						separator_before: false,
						separator_after: false,
						_disabled: false,
						labelKey: 'contextMenu.route.cut',
						titleKey: 'contextMenu.route.cut',
						action: function(event){
							utils.performButtonAction(undefined, undefined, {
								targetNodeIndex: event.reference.closest('li').attr('id')
							}, {
								fieldType: 'cut',
								context: 'route',
								componentInCharge: getComponent(event.reference.closest('.base_trees_tree'))
							});
						},
						icon: 'fi fi-cut',
						// shortcut: 13,
						// shortcut_label: 'Enter',
						submenu: false
					},
					paste: {
						separator_before: false,
						separator_after: false,
						_disabled: false,
						labelKey: 'contextMenu.route.paste.all',
						titleKey: 'contextMenu.route.paste.all',
						icon: 'fi fi-paste',
						// shortcut: 13,
						// shortcut_label: 'Enter',
						submenu: {
							pasteBefore: {
								separator_before: false,
								separator_after: false,
								_disabled: false,
								labelKey: 'contextMenu.route.paste.before',
								titleKey: 'contextMenu.route.paste.before',
								action: function(event){
									utils.performButtonAction(undefined, undefined, {
										targetNodeIndex: event.reference.closest('li').attr('id')
									}, {
										fieldType: 'paste',
										mode: 'before',
										context: 'route',
										componentInCharge: getComponent(event.reference.closest('.base_trees_tree'))
									});
								},
								icon: 'fi fi-paste',
								// shortcut: 13,
								// shortcut_label: 'Enter',
								submenu: false
							},
							pasteWithin: {
								separator_before: false,
								separator_after: false,
								_disabled: false,
								labelKey: 'contextMenu.route.paste.within',
								titleKey: 'contextMenu.route.paste.within',
								action: function(event){
									utils.performButtonAction(undefined, undefined, {
										targetNodeIndex: event.reference.closest('li').attr('id')
									}, {
										fieldType: 'paste',
										mode: 'child',
										context: 'route',
										componentInCharge: getComponent(event.reference.closest('.base_trees_tree'))
									});
								},
								icon: 'fi fi-paste',
								// shortcut: 13,
								// shortcut_label: 'Enter',
								submenu: false
							},
							pasteAfter: {
								separator_before: false,
								separator_after: false,
								_disabled: false,
								labelKey: 'contextMenu.route.paste.after',
								titleKey: 'contextMenu.route.paste.after',
								action: function(event){
									utils.performButtonAction(undefined, undefined, {
										targetNodeIndex: event.reference.closest('li').attr('id')
									}, {
										fieldType: 'paste',
										mode: 'after',
										context: 'route',
										componentInCharge: getComponent(event.reference.closest('.base_trees_tree'))
									});
								},
								icon: 'fi fi-paste',
								// shortcut: 13,
								// shortcut_label: 'Enter',
								submenu: false
							},
						}
					},
					showProperties: {
						separator_before: false,
						separator_after: false,
						_disabled: false,
						labelKey: 'contextMenu.route.showProperties',
						titleKey: 'contextMenu.route.showProperties',
						action: function(event){
							utils.performButtonAction(undefined, undefined, {
								startWithRegisterSecret: 'routeProperties'
							}, {
								fieldType: 'edit',
								context: 'routeContent',
								componentInCharge: getComponent(event.reference.closest('.base_trees_tree'))
							});
						},
						icon: 'fi fi-showProperties-route',
						// shortcut: 13,
						// shortcut_label: 'Enter',
						submenu: false
					}
				}
			},
			node_customize: {
				default: () => {}
			},
			// plugins: [
			// 'contextmenu', 'dnd', 'search',
			// 'state', 'types', 'wholerow'
			// 'state',
			// 'types',
			// 'checkbox'
			// 'contextmenu',
			// 'dnd'
			// ]
		}
	},

	methods: {
		onBuild: function(storage){
			// keep component as function context
			this.config.treeConfig.node_customize.default = (el, node) => this.customizeTreeNode(el, node);

			this.translateContextMenu()
		},
		customizeTreeNode: function(el, node){
			var contentParts = []
			var bubbles = [];
			var resource = ((node || {}).original || {}).resource || {};

			var categories = resource.categories || [];
			var category, categoryData, c, cD;
			for(c in categories){
				category = categories[c];

				for(cD in category.children){
					categoryData = categories[c].children[cD];
					bubbles.push(`<div class="nav-bubble${(category.turnedOff || (category.turnedOffByInheritance && !category.turnedOn)) && category.turnedOffTagCategoryManagement ? ' showTurnedOff' : ''}" title="${categoryData.name}" style="background-color: ${(categoryData.resources || {}).color || '#333333'};"></div>`);
				}
			}
			contentParts.push(`<div class="nav-bubbles">${bubbles.join('')}</div>`)

			if(this.config.parentConfig.showLanguageConnectionWarnings){
				var langCode, missingLangCodeConnections = [], multipleLangCodeConnections = [];
				var realLangCodes = {}
				for(langCode in resource.routeLanguageConnections || {}){
					if(!!langCode && langCode !== 'NO_LANG'){
						realLangCodes[langCode] = true
					}
					if(resource.routeLanguageConnections[langCode] === null && !!resource.langCode && resource.langCode !== langCode && !!langCode && langCode !== 'NO_LANG'){
						missingLangCodeConnections.push(langCode);
					} else if (utils.collectionSize(resource.routeLanguageConnections[langCode]) > 1){
						multipleLangCodeConnections.push(langCode);
					}
				}
				if(Object.keys(realLangCodes).length > 1 && missingLangCodeConnections.length > 0){
					contentParts.push(`<div class="entryWarning" title="${storage.__('error:routeTree:missingRoutesLanguageConnections', {langCodes: missingLangCodeConnections.join(', ')})}"><i class="fi fi-exclamation-triangle"/></div>`)
				}
				if(multipleLangCodeConnections.length > 0){
					contentParts.push(`<div class="entryError" title="${storage.__('error:routeTree:nonUniqueRouteLanguage', {langCodes: multipleLangCodeConnections.join(', ')})}"><i class="fi fi-exclamation-triangle"/></div>`)
				}
				if(resource.langCode === null || resource.langCode === 'NO_LANG'){
					contentParts.push(`<div class="entryError" title="${storage.__('error:routeTree:missingRouteLanguage')}"><i class="fi fi-exclamation-triangle"/></div>`)
				}
			}

			if(this.config.parentConfig.showLayoutWarnings){
				if(resource.parentRouteID === 0 && !resource.templateID){
					contentParts.push(`<div class="entryError" title="${storage.__('error:routeTree:missingTemplateID')}"><i class="fi fi-exclamation-triangle"/></div>`)
				}
			}

			$(`<div class="entryRightStatusContainer">${contentParts.join('')}</div>`).insertAfter($(el).find('> a'))
		}
	}
};
